import { transformToCounselor } from '../Counselor/CounselorTransformers';
import { CounselorOverview, CounselorOverviewResource } from './CounselorOverview';

export const transformToCounselorOverview = (
    counselorOverviewResource: CounselorOverviewResource,
): CounselorOverview => ({
    totalAmount: counselorOverviewResource.meta.totalAmount,
    counselors: counselorOverviewResource.organisationCounselors.map(transformToCounselor),
});
